import React, { useEffect, useState } from "react";
import Header from "../../layout/header";
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../Images/no-data-found.webp"

const HealthCard = ({
  healthCard,
  healthCardRes = [],
  match,
  healthcardDealerProfileData,
  getProfileData = [],
  dealerById,
  dealerByIdDetails = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await healthCard(match?.params?.id);
      await dealerById(match?.params?.id, "ncd");
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await healthcardDealerProfileData(
        1,
        15,
        match?.params?.id,
        "test_drive",
        "test_drive",
        "test_drive"
      );
      setIsLoading(false);
    })();
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true)
    await healthcardDealerProfileData(
        val?.selected + 1,
        15,
        match?.params?.id,
        "test_drive",
        "test_drive",
        "test_drive"
      );
    setIsLoading(false)
};


  // console.log("testing:", getProfileData?.package_details?.results[0]['name']);
  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Health Card"} />
            {/*BODY*/}
            {getProfileData?.headth_card && (
              <div className="">
                <div className="card">
                  <div
                    className="card-header"
                    style={{ backgroundColor: "#473381", color: "white" }}
                  >
                    Dealer Details
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-0 bg-white">
                        <div className="card-body">
                          <div className="user">
                            {getProfileData !== null &&
                              getProfileData?.headth_card?.ticket_summary?.map(
                                (ticket, index) => (
                                  <>
                                    {ticket.category !== "Service" &&
                                      ticket.category !==
                                        "Driver pick-up issues" &&
                                      ticket.category !==
                                        "Driver trip issues" && (
                                        <div
                                          className="form-group row"
                                          key={index}
                                        >
                                          <div className="col-md-12 col-sm-12">
                                            <div className="">
                                              <div
                                                className="card shadow"
                                                style={{ width: "100%" }}
                                              >
                                                <div className="card-body">
                                                  <h4 className="small font-weight-bold text-black-100">
                                                    {ticket.category}
                                                    <span className="float-right"></span>
                                                  </h4>

                                                  <hr className="hr-line" />
                                                  <div className="d-flex">
                                                    <div className="sl text-center sl-border">
                                                      <span className="bgs">
                                                        Reopened
                                                      </span>
                                                      <a
                                                        href={
                                                          "pie-list-account/11"
                                                        }
                                                      >
                                                        <span>
                                                          {ticket?.status_counts
                                                            ?.Reopened !==
                                                          undefined
                                                            ? ticket
                                                                ?.status_counts
                                                                ?.Reopened
                                                            : 0}
                                                        </span>
                                                      </a>
                                                    </div>
                                                    <div className="sl text-center sl-border">
                                                      <span className="">
                                                        Open
                                                      </span>
                                                      <a href={"list-account"}>
                                                        <span>
                                                          {ticket?.status_counts
                                                            ?.Open !== undefined
                                                            ? ticket
                                                                ?.status_counts
                                                                ?.Open
                                                            : 0}
                                                        </span>
                                                      </a>
                                                    </div>
                                                    <div className="sl text-center ">
                                                      <span className="cgs">
                                                        Closed
                                                      </span>
                                                      <span>
                                                        {ticket?.status_counts
                                                          ?.Closed !== undefined
                                                          ? ticket
                                                              ?.status_counts
                                                              ?.Closed
                                                          : 0}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </>
                                )
                              )}
                            <div className="row">
                              {dealerByIdDetails !== null &&
                                dealerByIdDetails?.data &&
                                dealerByIdDetails?.data?.trade_name && (
                                  <div className="col-md-6 float-field ">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      value={
                                        dealerByIdDetails?.data?.trade_name
                                      }
                                    />
                                    <label className="large-label float-lb">
                                      Dealer Name:<i className=""></i>
                                    </label>
                                  </div>
                                )}

                              {getProfileData !== null &&
                                getProfileData?.headth_card &&
                                getProfileData?.headth_card
                                  ?.last_30_days_issuance !== undefined && (
                                  <div className="col-md-6 float-field ">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      value={
                                        getProfileData?.headth_card
                                          ?.last_30_days_issuance
                                      }
                                    />
                                    <label className="large-label float-lb">
                                      Last 30 days insurance:
                                      <i className=""></i>
                                    </label>
                                  </div>
                                )}
                            </div>

                            <div className="row">
                              {getProfileData !== null &&
                                getProfileData?.headth_card &&
                                getProfileData?.headth_card
                                  ?.stock_ageing_80_days !== undefined && (
                                  <div className="col-md-6 float-field ">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      value={
                                        getProfileData?.headth_card
                                          ?.stock_ageing_80_days
                                      }
                                    />
                                    <label className="large-label float-lb">
                                      Stock Ageing(80 days):<i className=""></i>
                                    </label>
                                  </div>
                                )}
                              {getProfileData !== null &&
                                getProfileData?.headth_card &&
                                getProfileData?.headth_card
                                  ?.stock_ageing_90_days !== undefined && (
                                  <div className="col-md-6 float-field ">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      value={
                                        getProfileData?.headth_card
                                          ?.stock_ageing_90_days
                                      }
                                    />
                                    <label className="large-label float-lb">
                                      Stock Ageing(90 days):<i className=""></i>
                                    </label>
                                  </div>
                                )}
                            </div>
                            <div className="row">
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.bad_insurance_count||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                  Bad issuance count MTD:<i className=""></i>
                                </label>
                              </div>
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.servicing_summary?.total_mcd||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                No. of users who have added dealer as "My Car Dealer":<i className=""></i>
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.servicing_summary?.ftd_mcd||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                No of users who have added dealer as "My Car Dealer" yesterday:<i className=""></i>
                                </label>
                              </div>
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.servicing_summary?.mtd_mcd||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                No of users who have added dealer as "My Car Dealer" MTD:<i className=""></i>
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.servicing_summary?.last_thirty_days_mcd||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                No of users who have added dealer as "My Car Dealer" in the last 30 days:<i className=""></i>
                                </label>
                              </div>
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.servicing_summary?.total_service_leads||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                Users who have added dealer as "My Car Dealer" and booked servicing:<i className=""></i>
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.servicing_summary?.ftd_service_leads||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                No of users who have added dealer as "My Car Dealer" and booked servicing yesterday:<i className=""></i>
                                </label>
                              </div>
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.servicing_summary?.mtd_service_leads||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                No of users who have added dealer as "My Car Dealer" and booked servicing MTD:<i className=""></i>
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 float-field ">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  value={
                                    getProfileData?.servicing_summary?.last_thirty_days_service_leads||'N/A'
                                  }
                                />
                                <label className="large-label float-lb">
                                No of users who have added dealer as "My Car Dealer" and booked servicing in the last 30 days:<i className=""></i>
                                </label>
                              </div>
                            </div>
                            {/* <div className="row">
                              {getProfileData !== null &&
                                getProfileData?.package_details?.results &&
                                getProfileData?.package_details?.results?.[0]
                                  ?.name !== undefined && (
                                  <div className="col-md-6 float-field ">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      value={
                                        getProfileData?.package_details?.results?.[0]?.name
                                      }
                                    />
                                    <label className="large-label float-lb">
                                      Package Name:<i className=""></i>
                                    </label>
                                  </div>
                                )}
                              {getProfileData !== null &&
                                getProfileData?.package_details?.results &&
                                getProfileData?.package_details?.results?.[0]
                                  ?.no_of_leads !== undefined && (
                                  <div className="col-md-6 float-field ">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      value={
                                        getProfileData?.package_details?.results?.[0]?.no_of_leads
                                      }
                                    />
                                    <label className="large-label float-lb">
                                      No. of Leads:<i className=""></i>
                                    </label>
                                  </div>
                                )}
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {getProfileData?.activity_type && (
              <div className="">
                {/*Heading*/}
                <div className="d-sm-flex align-items-center justify-content-between com-heading">
                  <h1 className="h3 mb-0 text-black-100">Meeting Details</h1>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-0 bg-white">
                      <div className="div-com-header"></div>
                      <div className="card-body">
                        <div className="user">
                          <div className="form-group row">
                            {getProfileData !== null &&
                              getProfileData?.total_meeting && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={getProfileData?.total_meeting}
                                  />
                                  <label className="large-label float-lb">
                                    Mtd Visit Count:<i className=""></i>
                                  </label>
                                </div>
                              )}
                            {getProfileData !== null &&
                              getProfileData?.activity_type !== null &&
                              getProfileData?.activity_type?.name && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={getProfileData?.activity_type?.name}
                                  />
                                  <label className="large-label float-lb">
                                    Meeting Type:<i className=""></i>
                                  </label>
                                </div>
                              )}

                            {getProfileData !== null &&
                              getProfileData?.activity_date && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={getProfileData?.activity_date}
                                  />
                                  <label className="large-label float-lb">
                                    Meeting Date:<i className=""></i>
                                  </label>
                                </div>
                              )}
                            {/*{getProfileData!== null && getProfileData?.purpose_of_visit && (*/}
                            {/*    <div className="col-md-6 float-field ">*/}
                            {/*        <input type="text"*/}
                            {/*               className="form-control form-control-user"*/}
                            {/*               value={getProfileData?.purpose_of_visit}*/}
                            {/*        />*/}
                            {/*        <label className="large-label float-lb">*/}
                            {/*            Purpose of visit:<i className=""></i>*/}
                            {/*        </label>*/}
                            {/*    </div>*/}
                            {/*)}*/}
                            {getProfileData !== null &&
                              getProfileData?.attendance !== null &&
                              getProfileData?.attendance?.check_in_date && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={
                                      getProfileData?.attendance?.check_in_date
                                    }
                                  />
                                  <label className="large-label float-lb">
                                    Check in time:<i className=""></i>
                                  </label>
                                </div>
                              )}
                            {getProfileData !== null &&
                              getProfileData?.user !== null &&
                              getProfileData?.user?.name && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={
                                      getProfileData?.user?.name +
                                      "(" +
                                      getProfileData?.user?.email +
                                      ")"
                                    }
                                  />
                                  <label className="large-label float-lb">
                                    Conducted By:<i className=""></i>
                                  </label>
                                </div>
                              )}
                            {getProfileData !== null &&
                              getProfileData?.duration && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={getProfileData?.duration + "m"}
                                  />
                                  <label className="large-label float-lb">
                                    Meeting Duration:<i className=""></i>
                                  </label>
                                </div>
                              )}
                            {getProfileData !== null &&
                              getProfileData?.purpose_of_visit && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={getProfileData?.purpose_of_visit}
                                  />
                                  <label className="large-label float-lb">
                                    Purpose of visit:<i className=""></i>
                                  </label>
                                </div>
                              )}
                            {getProfileData !== null &&
                              getProfileData?.designation && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={getProfileData?.designation}
                                  />
                                  <label className="large-label float-lb">
                                    Designation:<i className=""></i>
                                  </label>
                                </div>
                              )}
                            {getProfileData !== null &&
                              getProfileData?.dealer_feedback &&
                              getProfileData?.dealer_feedback[0] !==
                                undefined &&
                              getProfileData?.dealer_feedback[0] !== null && (
                                <>
                                  {getProfileData?.dealer_feedback[0]
                                    ?.feedback && (
                                    <div className="col-md-6 float-field ">
                                      <input
                                        type="text"
                                        className="form-control form-control-user"
                                        value={
                                          getProfileData?.dealer_feedback[0]
                                            ?.feedback
                                        }
                                      />
                                      <label className="large-label float-lb">
                                        Dealer Feedback:<i className=""></i>
                                      </label>
                                    </div>
                                  )}

                                  {getProfileData?.dealer_feedback[0]
                                    ?.rating && (
                                    <div className="col-md-6 float-field ">
                                      <input
                                        type="text"
                                        className="form-control form-control-user"
                                        value={
                                          getProfileData?.dealer_feedback[0]
                                            ?.rating
                                        }
                                      />
                                      <label className="large-label float-lb">
                                        Rating:<i className=""></i>
                                      </label>
                                    </div>
                                  )}

                                  {getProfileData?.dealer_feedback[0]
                                    ?.bad_issuance &&
                                    getProfileData?.dealer_feedback[0]
                                      ?.bad_issuance[0] !== undefined && (
                                      <>
                                        <div className="col-sm-6 mtk-075 float-field mb-4">
                                          <label
                                            className="large-label"
                                            style={{ color: "#1b7cef" }}
                                          >
                                            Terms and Conditions(Bad Issuance)
                                          </label>
                                          <textarea
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            value={
                                              getProfileData?.dealer_feedback[0]
                                                ?.bad_issuance[0]
                                                ?.terms_and_conditions
                                            }
                                            rows="4"
                                            cols="50"
                                          />
                                        </div>
                                      </>
                                    )}            
                                </>
                              )}
                            {getProfileData !== null &&
                              getProfileData?.meta_data &&
                              getProfileData?.meta_data[0] !== undefined &&
                              getProfileData?.meta_data[0] !== null &&
                              getProfileData?.meta_data[0]?.MOM && (
                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                  <label
                                    className="large-label"
                                    style={{ color: "#1b7cef" }}
                                  >
                                    MOM
                                  </label>
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    value={getProfileData?.meta_data[0]?.MOM}
                                    rows="4"
                                    cols="50"
                                  />
                                </div>
                              )}

                            {getProfileData !== null &&
                              getProfileData?.meta_data &&
                              getProfileData?.meta_data[0] !== undefined &&
                              getProfileData?.meta_data[0] !== null &&
                              getProfileData?.meta_data[0]?.checked && (
                                <div className="col-md-6 float-field ">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    value={
                                      getProfileData?.meta_data[0]?.checked
                                    }
                                  />
                                  <label className="large-label float-lb">
                                    Waited Y/N:<i className=""></i>
                                  </label>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* cards start */}
            <div className="card">
              <div
                className="card-header"
                style={{ backgroundColor: "#473381", color: "white" }}
              >
                Test Drive Details
              </div>
              
              {getProfileData &&
                getProfileData?.dsm_dealer_info !== undefined && (
                  
                  <div className="card">
                      <div className="row list-view">
                        <div className="row col-md-12">
                            <div className="col-md-6">
                            <div className="d-flex">
                            <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Package Name:
                                </div>
                                {getProfileData !== null &&
                                getProfileData?.package_details?.results &&
                                (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                      getProfileData?.package_details?.results?.[0]
                                      ?.name
                                    }
                                    >
                                    {
                                        getProfileData?.package_details?.results?.[0]
                                        ?.name || 'N/A'
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>

                            <div className="col-md-6">
                            <div className="d-flex">
                            <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;No. of Leads:
                                </div>
                                {getProfileData !== null &&
                                getProfileData?.package_details?.results && (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                      getProfileData?.package_details?.results?.[0]
                                      ?.no_of_leads
                                    }
                                    >
                                    {
                                        getProfileData?.package_details?.results?.[0]
                                        ?.no_of_leads || 'N/A'
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>
                        </div>
                    </div>

                    <div
                      className="card-header"
                      style={{ backgroundColor: "#473381", color: "white" }}
                    >
                      Lead Details
                    </div>
                    <div className="row list-view">
                        <div className="row col-md-12">
                            <div className="col-md-6">
                            <div className="d-flex">
                            <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Total Assigned Leads Count:
                                </div>
                                {getProfileData?.dsm_dealer_info
                                ?.total_assigned_leads_count !== null && (
                                <div className="col-md-6 col-sm-6">
                                  
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                        getProfileData?.dsm_dealer_info
                                        ?.total_assigned_leads_count
                                    }
                                    >
                                    {
                                        getProfileData?.dsm_dealer_info
                                        ?.total_assigned_leads_count
                                    }
                                    </span>
                                
                                </div>
                                )}
                            </div>
                            </div>

                            <div className="col-md-6">
                            <div className="d-flex">
                                <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Total Pending Leads Count:
                                </div>
                                {getProfileData?.dsm_dealer_info
                                ?.total_pending_leads_count !== null && (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                        getProfileData?.dsm_dealer_info
                                        ?.total_pending_leads_count
                                    }
                                    >
                                    {
                                        getProfileData?.dsm_dealer_info
                                        ?.total_pending_leads_count
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>
                        </div>

                        <div className="row col-md-12">
                            <div className="col-md-6">
                            <div className="d-flex">
                                <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Total Acknwledged Leads Count:
                                </div>
                                {getProfileData?.dsm_dealer_info
                                ?.total_acknowledged_leads_count && (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                        getProfileData?.dsm_dealer_info
                                        ?.total_acknowledged_leads_count
                                    }
                                    >
                                    {
                                        getProfileData?.dsm_dealer_info
                                        ?.total_acknowledged_leads_count
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>
                            
                            <div className="col-md-6">
                            <div className="d-flex">
                                <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Total Scheduled Leads Count:
                                </div>
                                {getProfileData?.dsm_dealer_info
                                ?.total_scheduled_leads_count && (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                        getProfileData?.dsm_dealer_info
                                        ?.total_scheduled_leads_count
                                    }
                                    >
                                    {
                                        getProfileData?.dsm_dealer_info
                                        ?.total_scheduled_leads_count
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>
                        </div>

                        <div className="row col-md-12">
                            <div className="col-md-6">
                            <div className="d-flex">
                                <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Total Completed Leads Count:
                                </div>
                                {getProfileData?.dsm_dealer_info
                                ?.total_completed_leads_count && (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                        getProfileData?.dsm_dealer_info
                                        ?.total_completed_leads_count
                                    }
                                    >
                                    {
                                        getProfileData?.dsm_dealer_info
                                        ?.total_completed_leads_count
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>

                            <div className="col-md-6">
                            <div className="d-flex">
                                <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Total Lost Leads Count:</div>
                                {getProfileData?.dsm_dealer_info
                                ?.total_lost_leads_count && (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                        getProfileData?.dsm_dealer_info
                                        ?.total_lost_leads_count
                                    }
                                    >
                                    {
                                        getProfileData?.dsm_dealer_info
                                        ?.total_lost_leads_count
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>
                        </div>

                        <div className="row col-md-12">
                            
                        <div className="col-md-6">
                            <div className="d-flex">
                                <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Total Masked Leads Count:</div>
                                {getProfileData?.dsm_dealer_info
                                ?.total_masked_leads_count && (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                        getProfileData?.dsm_dealer_info
                                        ?.total_masked_leads_count
                                    }
                                    >
                                    {
                                        getProfileData?.dsm_dealer_info
                                        ?.total_masked_leads_count
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>

                            <div className="col-md-6">
                            <div className="d-flex">
                                <div className="col-md-6 col-sm-6 no-wrap">
                                &nbsp;&nbsp;Total Follow Up Leads Count:</div>
                                {getProfileData?.dsm_dealer_info
                                ?.total_follow_up_leads_count && (
                                <div className="col-md-6 col-sm-6">
                                    <span
                                    className="trigger"
                                    data-tooltip-id="1"
                                    title={
                                        getProfileData?.dsm_dealer_info
                                        ?.total_follow_up_leads_count
                                    }
                                    >
                                    {
                                        getProfileData?.dsm_dealer_info
                                        ?.total_follow_up_leads_count
                                    }
                                    </span>
                                </div>
                                )}
                            </div>
                            </div>
                        </div>
                    </div>
                  </div>
               )}

              {getProfileData &&
              getProfileData?.package_details !== undefined &&
              getProfileData?.package_details?.results !== undefined && (
                <div className="card">
                  <div className="card-header" style={{ backgroundColor: "#473381", color: "white" }}>
                    Package Details
                  </div>
                  <div className="card-body">
                    {getProfileData.package_details.results.some(pkg => pkg.status === 'ACTIVE') && (
                      <div className="package-section">
                        <h5 className="section-header" style={{ color: "#473381" }}>
                          Active Packages
                        </h5>
                        {getProfileData.package_details.results.filter(pkg => pkg.status === 'ACTIVE').map((pkg, index) => (
                          <div className="card mb-3" key={index}>
                            <div className="card-header">
                              {pkg.name}
                            </div>
                            <div className="row list-view">
                              <div className="col-md-4">
                                <b>Package Type:</b> {pkg.name || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Start Date:</b> {pkg.start_date || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>End Date:</b> {pkg.end_date || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Days Remaining:</b> {pkg.days_remaining || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Leads Remaining:</b> {pkg.leads_remaining || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Leads Sent:</b> {pkg.leads_sent_count || 'N/A'}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    {getProfileData.package_details.results.some(pkg => pkg.status === 'EXPIRED') && (
                      <div className="package-section">
                        <h5 className="section-header" style={{ color: "#473381" }}>
                          Expired Packages
                        </h5>
                        {getProfileData.package_details.results.filter(pkg => pkg.status === 'EXPIRED').map((pkg, index) => (
                          <div className="card mb-3" key={index}>
                            <div className="card-header">
                              {pkg.name}
                            </div>
                            <div className="row list-view">
                              <div className="col-md-4">
                                <b>Package Type:</b> {pkg.name || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Start Date:</b> {pkg.start_date || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>End Date:</b> {pkg.end_date || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Days Remaining:</b> {pkg.days_remaining || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Leads Remaining:</b> {pkg.leads_remaining || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Leads Sent:</b> {pkg.leads_sent_count || 'N/A'}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {getProfileData.package_details.results.length === 0 && (
                      <div className="text-center">
                        No package details available.
                      </div>
                    )}
                  </div>
                </div>
              )}

              {getProfileData &&
              getProfileData?.servicing_user_details !== undefined && (
                <div className="card">
                  <div className="card-header" style={{ backgroundColor: "#473381", color: "white" }}>
                    User Details (users who have added dealer as "My Car Dealer" and booked servicing)
                  </div>
                  <div className="card-body">
                      <div className="package-section">
                        
                        {getProfileData.servicing_user_details.slice(0, 5).map((user, index) => (
                          <div className="card mb-3" key={index}>
                            <div className="card-header">
                              {user.name || 'N/A'}
                            </div>
                            <div className="row list-view">
                              <div className="col-md-4">
                                <b>Vehicle Number:</b> {user.vehicle_number || 'N/A'}
                              </div>
                              <div className="col-md-4">
                                <b>Date:</b> {user.date || 'N/A'}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    
                    {getProfileData.servicing_user_details.length === 0 && (
                      <div className="text-center">
                        No user details available.
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="row">
                {/* CARD START */}
                {getProfileData &&
                  getProfileData.dealer_listing_analytics !== undefined &&
                  getProfileData.dealer_listing_analytics.results !==
                    undefined &&
                  getProfileData.dealer_listing_analytics.results.map(
                    (val, i) => (
                      <div className="card-body" style={{width: "100%"}} key={i}>
                        <div className="col-md-12 col-sm-6" style={{width: "inherit"}}>
                          <div className="card-big-shadow">
                            <div
                              className="card card-just-text"
                              data-radius="none"
                            >
                              <div className="content">
                                <h6 className="category mrg-b-12">
                                <div className="row">
                                    <div className="col-10" style={{
                                        color: "#000",
                                        fontSize: "20px",
                                        textAlign: "left",
                                        paddingLeft: "20px"
                                    }}>
                                        <div className="d-flex">
                                            {"(" + val?.dealership_name + ")"}
                                        </div>

                                    </div>
                                </div>
                                <div className="row list-view">
                      <div className="mb-flex">
                        <div className="col-md-6 col-sm-6 no-wrap">
                          <i className="fa fa-address-card"></i>
                          &nbsp;&nbsp;Package Name
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <span
                            className="trigger"
                            data-tooltip-id="1"
                            title={val.name ? val.name : 'N/A'}
                          >
                          {val.name ? val.name : 'N/A'}
                          </span>
                        </div>
                      </div>

                      <div className="mb-flex">
                        <div className="col-md-6 col-sm-6 no-wrap">
                          <i className="bi bi-map" aria-hidden="true"></i>
                          &nbsp;&nbsp;No. Of Leads
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <span
                            className="trigger"
                            data-tooltip-id="1"
                            title={val.no_of_leads || 'N/A'}
                          >
                            {val.no_of_leads || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>

                                  <hr />
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
              </div>
            </div>
{/* 
            {getProfileData && getProfileData?.dealer_listing_analytics !== undefined && getProfileData?.dealer_listing_analytics?.results !== undefined && getProfileData?.dealer_listing_analytics?.results?.length > 0 &&
            <div className="panel-pagination-col panel-table-pagination">
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={(getProfileData.dealer_listing_analytics?.total / getProfileData.dealer_listing_analytics?.per_page)}
                    forcePage={getProfileData.dealer_listing_analytics?.current_page - 1}
                    pageRangeDisplayed={4}
                    onPageChange={onPageChange}
                    activeClassName={'active'}
                />
            </div>
        }

        {getProfileData && getProfileData?.dealer_listing_analytics !== undefined && getProfileData?.dealer_listing_analytics?.results?.length === 0 &&
            <>
                <img src={NotFoundData} className="Dealer not found" alt={""}/>
                <div className="text-center" style={{"width": "100%"}}>
                    Data Not Found
                </div>
            </>
        } */}
          </div>
          {/* cards ends */}
        </div>
      </div>
    </>
  );
};

export default HealthCard;
